import React, { Component } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import moment from 'moment';
import Dialog from '../../../raven/modals/dialog';
import CognitoUtil from '../../../../aws/cognito/cognitoUtil';
import globalconfig from '../../../../common/config';

import "react-table/react-table.css";

export class RavenStatusHistoryView extends Component {

    render() {

        var columns = [
            {
                Header: 'Time',
                accessor: d => moment.utc(d.ts).unix() * 1000,
                id: 'ts',
                Cell: props => <span title={moment.utc(props.original.ts).unix()}>{ moment(props.value).format(globalconfig.display.timeFormat) } ( { moment(props.value).fromNow() } ) </span> ,
            },
            {
                Header: 'User',
                accessor: 'user',
            },
            {
                Header: 'Raven Id',
                accessor: 'raven_id',
                maxWidth: 100,
            },
            {
                Header: 'Raven Unit Id',
                accessor: 'raven_unit_id',
                maxWidth: 100,
            },
            {
                Header: 'From',
                accessor: 'from',
                maxWidth: 100,
            },
            {
                Header: 'To',
                accessor: 'to',
            },
        ];

        let datasize = this.props.data ? this.props.data.length : 0;
        let paginate = this.props.data ? datasize > this.props.pageSize : false;

        let pagesize = paginate ? this.props.pageSize : datasize;


        return (
            <div id="tombstone-listing" className="tombstone-list">
                    <ReactTable className="-striped" data={this.props.data}
                        filterable={true}
                        defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value) }
                        showPagination={paginate}
                        showPageSizeOptions={false}
                        showPageJump={false}
                        style = {{ height: "75vh"}}
                        pageSize={pagesize}
                        noDataText="No Status"
                        defaultSorted={[{ id: 'ts', desc: true }]}
                        columns={columns} />
            </div>
        );
    }
}


RavenStatusHistoryView.defaultProps = {
    pageSize: 100,
};

RavenStatusHistoryView.propTypes = {
    pageSize: PropTypes.number,
}

export default class RavenViewStatusModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ravenStatusHistory: [],
            loading: true
        }

    }

    getRavenHistoryStatus() {
        // perform ajax calls to get it the next state
        let url = "" + this.props.dataStore.prefix1 + "ajax"
                + "?stage=" + this.props.stage
                + "&type=ravenstatus"
                + "&raven=" + this.props.raven.raven_unit_id;

        console.debug("Fetching raven status history data:", url);

        return fetch(url,
            { method: 'POST', headers: { Authorization: CognitoUtil.getCurrentUserToken() } })
          .then((response) => {
           if (response.ok) {
               return response.json();
           } else {
               console.error("Failed to fetch raven status history data:", response);
               return [];
           }
        }).then((json) => {
            console.debug("Raven status history data:", json);
            this.setState({
                ravenStatusHistory: json,
                loading: false
            });
        }).catch((error) => {
            console.error("Error fetching raven status history:", error);
            this.setState({ loading: false });
        });
    }

    componentDidMount() {
        this.getRavenHistoryStatus();
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    !this.state.loading ?
                                        this.state.ravenStatusHistory && this.state.ravenStatusHistory.length !== 0 ?
                                            <RavenStatusHistoryView
                                                data={this.state.ravenStatusHistory}
                                            /> :
                                            <p>No Status History Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                    
                    </div>
            </Dialog>
        );
    }

}
